import { render } from "./AgencySettings.vue?vue&type=template&id=33255d9e&scoped=true"
import script from "./AgencySettings.vue?vue&type=script&lang=js"
export * from "./AgencySettings.vue?vue&type=script&lang=js"

import "./AgencySettings.vue?vue&type=style&index=0&id=33255d9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33255d9e"]])

export default __exports__